import React from "react";
import { parseOrdering, buildOrdering } from "../utils/filterParams";
import ContractRow from "./ContractRow";

// Only these 4 columns have a backend `ordering` value to sort by — plain
// <table>, not TableContainer/@tanstack, since TableContainer has no
// manualSorting/onSortingChange escape hatch (it would re-sort only the
// current page client-side and desync from the real server ordering).
const COLUMNS = [
  { key: "pvc_number", label: "PVC", sortable: true, defaultDir: "asc" },
  { key: "client", label: "Client", sortable: true, defaultDir: "asc" },
  { key: "next_payment", label: "Next payment", sortable: true, defaultDir: "asc" },
  { key: "notary", label: "Notary", sortable: false },
  { key: "type", label: "Type", sortable: false },
  { key: "notes", label: "Notes", sortable: false },
  { key: "pvc_date", label: "Date", sortable: true, defaultDir: "desc", align: "right" },
];

const ContractsTable = ({ contracts, ordering, onSortChange, onRowClick, canDelete, onDeleteRequest, formatCurrency }) => {
  const { field: activeField, dir: activeDir } = parseOrdering(ordering);

  const handleHeaderClick = (col) => {
    if (!col.sortable) return;
    const dir = activeField === col.key ? (activeDir === "asc" ? "desc" : "asc") : col.defaultDir;
    onSortChange(buildOrdering(col.key, dir));
  };

  return (
    <div className="table-responsive">
      <table className="table align-middle table-nowrap mb-0">
        <thead className="table-light text-muted">
          <tr>
            {COLUMNS.map((col) => (
              <th
                key={col.key}
                onClick={() => handleHeaderClick(col)}
                style={{
                  cursor: col.sortable ? "pointer" : "default",
                  textAlign: col.align || "left",
                  fontSize: 11,
                  fontWeight: 650,
                  letterSpacing: "0.6px",
                  textTransform: "uppercase",
                  whiteSpace: "nowrap",
                }}
              >
                {col.label}
                {col.sortable && activeField === col.key ? (activeDir === "asc" ? " ↑" : " ↓") : ""}
              </th>
            ))}
            <th style={{ width: 70 }}></th>
          </tr>
        </thead>
        <tbody>
          {contracts.map((contract) => (
            <ContractRow
              key={contract.id}
              contract={contract}
              onRowClick={onRowClick}
              canDelete={canDelete}
              onDeleteRequest={onDeleteRequest}
              formatCurrency={formatCurrency}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContractsTable;
